<div class="page-title animatedBackground">
    <div class="container">
        <h3>Cloud Services and Cyber Security</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li><a routerLink="/services">Services</a></li>
            <li class="dot-divider"></li>
            <li>Cloud Services and Cyber Security</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="services-details-desc">
                <h3>Find out what OSIT Cloud Computing Services can do.</h3>
                <p>The Cloud Computing model for fast-paced startups, SMBs, and enterprise organizations alike is here. Cloud computing applications have a dynamic infrastructure that offers many benefits to any kind of organization by empowering end-users with control over their shared computing resources. Reduce operational costs, enable device and location independence, maximize your performance, and improve your security with a cloud computing solution for your organization.</p>
               <p>&nbsp;<br></p>
                <h5>OSIT - a Cloud Computing one-stop shop:</h5>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Cloud Computing Software</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Cloud Computing SaaS</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Private Cloud Solutions</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> PaaS Providers</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Cloud Computing Providers</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Cloud Storage Providers</h4>
                </div>
            </div>

            <div class="services-details-image">
                <img src="assets/img/slide2.png" alt="image">
            </div>
        </div>

        <div class="services-details-overview">
            <div class="services-details-image">
                <img src="assets/img/fullbg3.png" alt="image">
            </div>

            <div class="services-details-desc">
                <h3>Cyber Security Consulting</h3>
                <p>We specialize in Cyber Security Assessment, Design, Implementation, Support and Managed Services for Small and Medium businesses with on-prem data centers. Our portfolio includes the following:</p>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Data Center Perimeter (External/Internal) Security</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Network Security</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Endpoint (Client/Server) Security</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Pen-Testing Solution (Web, Mobile and Network)</h4>
                </div>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Managed Security Services</h4>
                </div>
                <p>We also provide a Security Operations Center (SOC) as part of our Managed Control Center Services.</p>
            </div>
        </div>
    </div>
</section>

